import { render, staticRenderFns } from "./jumbo.vue?vue&type=template&id=52923633&scoped=true"
import script from "./jumbo.vue?vue&type=script&lang=js"
export * from "./jumbo.vue?vue&type=script&lang=js"
import style0 from "./jumbo.vue?vue&type=style&index=0&id=52923633&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52923633",
  null
  
)

export default component.exports